import * as React from "react";
import PropTypes from "prop-types";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Container } from "@mui/system";

import MailmanFormTab from "./mailmanFormTab";
import MailmanUploadTab from "./mailmanUploadTab";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MailmanForm() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="lg">
      <Box>
        <Typography variant="h4" mb={"2rem"} color={"#778692"}>
          Mailman
        </Typography>
      </Box>
      <Box
        sx={{
          // borderBottom: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{ width: "45rem", borderBottom: "1px solid #d8dde1" }}
        >
          <Tab
            label="Mailman Sender"
            {...a11yProps(0)}
            sx={{
              width: "50%",
              // backgroundColor: "#389382",
              borderTopLeftRadius: "10px",
              borderRight: "1px solid #d8dde1",
            }}
          />
          <Tab
            label="Upload New Files"
            {...a11yProps(1)}
            sx={{
              width: "50%",
              // backgroundColor: "#389382",
              borderTopRightRadius: "10px",
            }}
          />
        </Tabs>
      </Box>
      {value === 0 && (
        <Box sx={{ mt: "2rem" }}>
          <MailmanFormTab />
        </Box>
      )}
      {value === 1 && (
        <Box
          sx={{
            mt: "2rem",
            border: "1px solid #d8dde1",
            borderRadius: "10px",
            padding: "1rem",
          }}
        >
          <MailmanUploadTab />
        </Box>
      )}
    </Container>
  );
}
